module.exports = __webpack_public_path__ + "img/三星高级大师@3x.548ddb7b.png";